// Subtle haptic feedback. No-op on devices without the Vibration API (e.g. iOS Safari).
export const haptic = (pattern = 12) => {
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(pattern);
    }
  } catch {
    /* ignore */
  }
};
